import { Injectable, OnDestroy } from '@angular/core';
import { IPushNotify } from '@sv/interfaces';
import { Observable, of, timer } from 'rxjs';
import { delayWhen, map, retryWhen, switchMap, take } from 'rxjs/operators';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { customApp } from 'src/app/_configuration/configuration';
import { AuthService } from '../_auth/auth.service';
import { TicketcodeAuthService } from '../_auth/ticketcode-auth.service';
@Injectable({
  providedIn: 'root'
})
export class WebsocketService implements OnDestroy {
  constructor(private authService: AuthService, private ticketcodeAuth: TicketcodeAuthService) {}

  connection$: WebSocketSubject<any>;
  retryTimes = [1000, 10000, 60000, 600000]; // 1s, 10s, 1min, 10min
  connect(): Observable<IPushNotify> {
    document.cookie = 'X-Authorization=' + this.ticketcodeAuth.getToken();
    return of(`${customApp.url}/app/event/push?id=${this.ticketcodeAuth.decodeToken()?._id}`).pipe(
      // https becomes wws, http becomes ws
      map((apiUrl: string) => apiUrl.replace(/^http/, 'ws')),
      switchMap((wsUrl: string) => {
        if (this.connection$) {
          return this.connection$;
        } else {
          this.connection$ = webSocket(wsUrl);
          return this.connection$;
        }
      }),
      retryWhen((errors) =>
        errors.pipe(
          // retrys after 1s, 10s, 1min, 10min
          delayWhen((_, i) => {
            return timer(this.retryTimes[i]);
          }),
          take(4) // retry a maxium of 4 times
        )
      )
    );
  }

  send(data: any) {
    if (this.connection$) {
      const payload = {
        token: this.authService.getToken(),
        ...data
      };
      this.connection$.next(payload);
    } else {
      console.error('Did not send data, open a connection first');
    }
  }

  closeConnection() {
    if (this.connection$) {
      this.connection$.complete();
      this.connection$ = null;
    }
  }
  ngOnDestroy() {
    this.closeConnection();
  }
}
